var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.404 78.1089C37.404 78.1089 33.5444 80.3534 40.1508 81.1129C48.1543 82.026 52.2448 81.895 61.0647 80.2257C61.0647 80.2257 63.3835 81.6797 66.6219 82.939C46.85 91.4129 21.8743 82.4482 37.404 78.1089Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9886 67.0508C34.9886 67.0508 30.6596 70.2552 37.2709 70.939C45.8205 71.821 52.5723 71.8932 64.2555 69.6435C64.2555 69.6435 65.8714 71.2817 68.4124 72.1776C44.507 79.1679 17.8807 72.7289 34.9886 67.0508Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3561 48.2932C60.2279 53.9022 54.0761 58.9495 54.0761 58.9495C54.0761 58.9495 66.4463 52.5636 60.7652 44.5669C55.4592 37.1096 51.3903 33.4043 73.4181 20.6289C73.4181 20.6289 38.8417 29.2645 55.3561 48.2932Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.506 86.2878C81.506 86.2878 84.3622 88.6412 78.3604 90.4619C66.9478 93.9192 30.86 94.9632 20.8349 90.5997C17.2312 89.0319 23.9892 86.8562 26.115 86.3997C28.3321 85.919 29.599 86.0085 29.599 86.0085C25.5913 83.1853 3.69466 91.5522 18.4766 93.9483C58.7891 100.486 91.9625 91.0045 81.506 86.2878Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2607 55.5936C39.2607 55.5936 20.9042 59.9536 32.7602 61.5369C37.7662 62.2071 47.7455 62.0555 57.041 61.2766C64.6378 60.6358 72.2659 59.2733 72.2659 59.2733C72.2659 59.2733 69.5871 60.4205 67.6491 61.7438C49.0084 66.6463 12.9979 64.3656 23.3648 59.3509C32.1322 55.1128 39.2607 55.5936 39.2607 55.5936Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1899 74.0003C91.1391 64.1536 82.3777 54.691 76.2624 55.9658C74.7635 56.2778 74.0952 56.5481 74.0952 56.5481C74.0952 56.5481 74.6516 55.6764 75.7144 55.2991C87.8125 51.0458 97.1167 67.8436 71.809 74.4966C71.809 74.4969 72.1022 74.2347 72.1899 74.0003Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7657 0C60.7657 0 71.2601 10.4979 50.8122 26.6407C34.4152 39.59 47.0732 46.9734 50.8054 55.4092C41.2342 46.7736 34.2102 39.1716 38.9224 32.0964C45.8389 21.7107 64.9999 16.6753 60.7657 0Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1222 100.683C59.3111 101.847 87.2422 100.037 87.9037 91.4302C87.9037 91.4302 86.6321 94.6928 72.8716 97.2839C57.347 100.205 38.1996 99.8643 26.8431 97.9919C26.8434 97.9917 29.1679 99.916 41.1222 100.683Z",
    fill: "#5382A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/Java.df4892f68d559058dd23f16213822c7c.svg";
export { ForwardRef as ReactComponent };